import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';

export default function SelectOperatorModal({ open, type, operators, history, onClose, onSend }) {
    const [selected, setSelected] = useState([]);

    // Filter operators based on type (SMS/Email)
    const filteredOperators = operators.filter(row => {
        if (type === 'sms') {
            return row.smsTelephone && row.smsTelephone.length > 0;
        }
        if (type === 'email') {
            return row.email && row.email.length > 0;
        }
        return true;
    });

    useEffect(() => {
        if (open) {
            setSelected([]);
        }
    }, [open]);

    const handleToggle = (value) => () => {
        const currentIndex = selected.indexOf(value);
        const newChecked = [...selected];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setSelected(newChecked);
    };

    const handleSelectAll = () => {
        if (selected.length === filteredOperators.length) {
            setSelected([]);
        } else {
            setSelected(filteredOperators.map(op => op.operatorID));
        }
    };

    const getHistoryStatus = (operatorId) => {
        const log = history.find(h => h.operatorID === operatorId && h.type.toLowerCase() === type.toLowerCase());
        if (log) {
            return `ส่งแล้วเมื่อ ${new Date(log.sentAt).toLocaleString('th-TH')}`;
        }
        return null;
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>เลือกผู้ประกอบการเพื่อส่ง {type === 'sms' ? 'SMS' : 'Email'} แจ้งเตือน</DialogTitle>
            <DialogContent dividers>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="subtitle1">รายชื่อผู้ประกอบการ ({selected.length}/{filteredOperators.length})</Typography>
                    <Button onClick={handleSelectAll} color="primary">
                        {selected.length === filteredOperators.length ? "ยกเลิกการเลือกทั้งหมด" : "เลือกทั้งหมด"}
                    </Button>
                </Box>
                <List dense>
                    {filteredOperators.map((row) => {
                        const labelId = `checkbox-list-label-${row.operatorID}`;
                        const sentStatus = getHistoryStatus(row.operatorID);
                        const isSelected = selected.indexOf(row.operatorID) !== -1;

                        return (
                            <React.Fragment key={row.operatorID}>
                                <ListItem button onClick={handleToggle(row.operatorID)}>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={isSelected}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        id={labelId}
                                        primary={row.operatorName}
                                        secondary={
                                            <>
                                                {sentStatus ?
                                                    <Chip
                                                        label={sentStatus}
                                                        size="small"
                                                        style={{
                                                            backgroundColor: '#e8f5e9',
                                                            color: '#2e7d32',
                                                            marginTop: 4,
                                                            marginBottom: 4,
                                                            fontWeight: 500
                                                        }}
                                                    />
                                                    : null}
                                                {sentStatus && <br />}
                                                {type === 'sms' && <span style={{ fontSize: '0.8em', color: '#666' }}>Tel: {row.smsTelephone}</span>}
                                                {type === 'email' && <span style={{ fontSize: '0.8em', color: '#666' }}>Email: {row.email}</span>}
                                            </>
                                        }
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </React.Fragment>
                        );
                    })}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    ยกเลิก
                </Button>
                <Button
                    onClick={() => onSend(selected, type)}
                    color="primary"
                    variant="contained"
                    disabled={selected.length === 0}
                >
                    ส่งแจ้งเตือน ({selected.length})
                </Button>
            </DialogActions>
        </Dialog>
    );
}
